"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCell = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _table = require("../../data/table");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APInlineButton = _interopRequireDefault(require("../../common/APInlineButton"));
var _MarginClosePositionModal = _interopRequireDefault(require("../../MarginClosePosition/MarginClosePositionModal"));
var _MarginRepayLoanModal = _interopRequireDefault(require("../../MarginRepayLoan/MarginRepayLoanModal"));
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
require("./OpenPositions.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('open-positions-table');

/**
 *
 * @param {React.ReactNode} line1
 * @param {React.ReactNode} line2
 */

var renderCell = exports.renderCell = function renderCell(line1, line2) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line1')
  }, line1), !!line2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line2')
  }, line2));
};
var formatMoney = function formatMoney(value, product) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, product), /*#__PURE__*/_react["default"].createElement("span", {
    className: "-currency"
  }, product));
};
var OpenPositionsComponent = function OpenPositionsComponent(_ref) {
  var data = _ref.data,
    fetching = _ref.fetching,
    config = _ref.config,
    openClosePositionModal = _ref.openClosePositionModal,
    openRepayLoanModal = _ref.openRepayLoanModal,
    notionalProduct = _ref.notionalProduct;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      id: 'Pair',
      cell: function cell(_ref2) {
        var _row$original$instrum;
        var row = _ref2.row;
        return renderCell(((_row$original$instrum = row.original.instrument) === null || _row$original$instrum === void 0 ? void 0 : _row$original$instrum.Symbol) || '', row.original.PositionType);
      }
    }, {
      header: t('Size / Value'),
      id: 'Size',
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return renderCell(formatMoney(row.original.PositionAmount, row.original.BaseProductSymbol), formatMoney(row.original.PositionValue, row.original.QuoteProductSymbol));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Cost Basis / Entry Price'),
      id: 'Cost Basis',
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return renderCell(formatMoney(row.original.CostBasis, row.original.QuoteProductSymbol), formatMoney(row.original.EntryPrice, row.original.QuoteProductSymbol));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Unrealized / Realized P&L'),
      id: 'PnL',
      cell: function cell(_ref5) {
        var row = _ref5.row;
        // BigNumber is used for cases when value is like -0.00001 gets formatted to -0.00
        var unreliazedPnL = (0, _bignumber["default"])(row.original.UnrealizedPnL).dp(row.original.quoteProduct.DecimalPlaces, _bignumber["default"].ROUND_HALF_UP);
        var realizedPnL = (0, _bignumber["default"])(row.original.RealizedPnL).dp(row.original.quoteProduct.DecimalPlaces, _bignumber["default"].ROUND_HALF_UP);
        return renderCell(/*#__PURE__*/_react["default"].createElement("span", {
          className: unreliazedPnL.lt(0) ? '-negative' : ''
        }, formatMoney(unreliazedPnL, row.original.QuoteProductSymbol)), /*#__PURE__*/_react["default"].createElement("span", {
          className: realizedPnL.lt(0) ? '-negative' : ''
        }, formatMoney(realizedPnL, row.original.QuoteProductSymbol)));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Liability / Interest'),
      id: 'Liability',
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return renderCell(formatMoney(row.original.BorrowedAmount, row.original.PositionType === 'Long' ? row.original.QuoteProductSymbol : row.original.BaseProductSymbol), formatMoney(row.original.InterestAccrued, row.original.PositionType === 'Long' ? row.original.QuoteProductSymbol : row.original.BaseProductSymbol));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Used Margin / Initial'),
      id: 'UserMargin',
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return renderCell(formatMoney(row.original.UsedMarginNotional, notionalProduct.Product), Number(row.original.InitialRequirement).toLocaleString(undefined, {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Date/Time Opened'),
      id: 'DateOpened',
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return renderCell((0, _dateHelper.formatDate)(row.original.DateOpened), (0, _dateHelper.formatTime)(row.original.DateOpened));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Position ID'),
      id: 'PositionId',
      cell: function cell(_ref9) {
        var row = _ref9.row;
        return row.original.PositionId;
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Actions'),
      id: 'Actions',
      size: 130,
      meta: {
        fixedWidth: true
      },
      cell: function cell(_ref10) {
        var row = _ref10.row;
        return row.original.PositionState === 'InClosing' ? /*#__PURE__*/_react["default"].createElement("div", null, t('Closing')) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "positions-actions-buttons"
        }, /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
          text: t('Close'),
          dataTest: "Close",
          customClass: 'action-button',
          onClick: function onClick() {
            return openClosePositionModal(row.original, 'close');
          }
        }), row.original.BorrowedAmount === 0 ? /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
          text: t('Cancel'),
          dataTest: "Cancel",
          customClass: 'action-button',
          onClick: function onClick() {
            return openClosePositionModal(row.original, 'cancel');
          }
        }) : /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
          text: t('Repay'),
          dataTest: "repay",
          customClass: 'action-button',
          onClick: function onClick() {
            return openRepayLoanModal(row.original, 'repay');
          }
        }));
      }
    }];
  }, [t, openClosePositionModal, openRepayLoanModal, notionalProduct]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null), /*#__PURE__*/_react["default"].createElement(_MarginRepayLoanModal["default"], null), /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: data,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  }));
};

/*
 t('Positions', { ns: 'order' });
 */

OpenPositionsComponent.title = 'Positions';
OpenPositionsComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  notionalProduct: _propTypes["default"].shape({
    DecimalPlaces: _propTypes["default"].number.isRequired,
    Product: _propTypes["default"].string.isRequired
  }),
  openClosePositionModal: _propTypes["default"].func.isRequired,
  openRepayLoanModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = OpenPositionsComponent;